<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner class="spinner"/>
    </b-container>

    <b-container  v-else class="container">

        <router-link class="admin-link" to="/Admin/Users">&larr; Перейти к списку пользоватлей</router-link>


        <div class="admin-title">{{header}}</div>
        
        <b-tabs content-class="mt-3">

            <b-tab active title="Основная информация">

                <label for="FullName">ФИО*:</label>
                <b-form-input id ="FullName" v-model="entity.FullName" class="mb-13"/>
                
                <label for="DAX">DAX*:</label>
                <b-form-input id="DAX" v-model="entity.DAX" class="mb-13"/>

                <label for="Email">E-mail*:</label>
                <b-form-input id="Email" v-model="entity.Email" class="mb-13"/>

                <label for="Password">Пароль:</label>
                <b-form-input id="Password" v-model="entity.NewPassword" class="mb-13"/>

                <b-row>
                    <b-col :cols="rightsService.isPrivate(entity.Rights) ? 12 : 8">

                        <label for="Rights">Права доступа*:</label>
                        <custom-multiselect id="Rights" 
                                            v-model="entity.Rights"
                                            :options="rightsService.rights(selectedType)"
                                            class="mb-13"/>
                    </b-col>                        
                    <b-col v-if="!rightsService.isPrivate(entity.Rights)" >

                        <label for="Type">Тип:</label>
                        <custom-multiselect id="Type"
                                            v-model="selectedType"
                                            :options="rightsService.Type"                                                
                                            @select="isDaxUser"/>   

                    </b-col>
                </b-row>

                <label for="Post">Должность:</label>
                <b-form-input id="Post" v-model="entity.Post" class="mb-13"/>
            
                <label for="numderPhone">Мобильный телефон*:</label>
                <b-form-input id="numderPhone" v-model="entity.PhoneNumber" :formatter="format" placeholder="Формат: +99999999999" class="mb-13"/>

                <label for="Status">Статус*:</label>
                <custom-multiselect id="Status"
                                    v-model="entity.Status"
                                    :options="status"
                                    :preselect-first="true"
                                    class="mb-13"/>               
            </b-tab>

            <b-tab v-if="id" title="Версия приложения">

                <b-table outlined :items="entity.Devices" :fields="fields" />

                <label for="Comment">Заметки:</label>
                <b-form-textarea id="Comment"
                                 v-model="entity.Comment"        
                                 placeholder="Заметки о последних проблемах с пользователем, внесенные технической поддержкой"/>   
            </b-tab>

            <b-tab v-if="id" title="Отправка уведомления">

                <label for="Push">Уведомление:</label>
                <b-form-textarea id="Push" v-model="pushText" class="mb-13"/>   

                <b-button id="admin-btn-neutral"
                          class="admin-button"
                          @click="sendPush">
                    Отправить
                </b-button>

            </b-tab>
        </b-tabs>

        <hr class="my-4">

        <b-row class="m-0">

            <b-col lg="2" sm="4" class="p-0 mr-10">
                <b-button block 
                        id="admin-btn-save"
                        class="admin-button"
                        @click="updateUser">
                    Сохранить
                </b-button>
            </b-col>

            <b-col lg="2" sm="4" class="p-0">
                <b-button block v-if="id"
                        id="admin-btn-cancel"
                        class="admin-button"
                        @click="deleteUserDialog">
                    Удалить
                </b-button>
            </b-col>

        </b-row>

    </b-container>
</template>
<script>
import apiService from "@/services/api.service"
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import RightsService from "@/store/models/admin/rightService"
import UserEditModel from "@/store/models/admin/users/UserEdit"
import Consts from "@/store/models/consts/adminConsts"

import Loading from '@/store/models/Loading'
import Spinner from "@/components/shared/Spinner"

import CustomMultiselect from '@/components/shared/CustomMultiSelect'

export default {
    computed: {
            header: function() {
                return this.id ? "Редактирование пользователя" : "Создание нового пользователя";
            },
            selectedType: {
                get: function() {
                    if(!this.id) return;

                    return this.rightsService.isPrivate(this.entity.Rights)
                                             ? this.rightsService.Private
                                             : this.rightsService.Public;                             
                },
                set: function(value) {
                    this.rightsService.isPrivate(value)
                                            ? this.entity.Rights = this.rightsService.Auditor
                                            : this.entity.Rights = this.rightsService.NotDaxUser;
                }
            }           
        },
        data: function() {

            let id = Object.keys(this.$route.query).length
                        ? this.$route.query.id
                        : null;

            let entityTemp = null;
            let load = new Loading();
    
            if(id)
                this.getUser(id, load) 
            else
                entityTemp = new UserEditModel();

            return {
                load: load,

                id: id,
                entity: entityTemp,

                status: Consts.UserStatus,                
                pushText: "",
                
                rightsService: new RightsService(),    
                fields: [
                    { key: 'Device', label: 'Девайс'},
                    { key: 'Branch', label: 'Филиал'},
                    { key: 'AppVersion', label: 'Версия Мау'},
                    { key: 'OsVersion', label: 'Версия ОС'},
                    { 
                        key: 'LastLogin', 
                        label: 'Последний вход',
                        formatter: value => {
                            return `${value.getDate()}.${value.getMonth()+1}.${value.getFullYear()} ${value.getHours()}:${value.getMinutes()}:${value.getSeconds()}`;
                        }
                    },
                ]            
            };
        },
        methods: { 
            getUser: function(id, load) {
                load.Calculate(true);

                apiService.Admin.Users.Get(id)
                    .then(response => {
                        this.entity = new UserEditModel().mapFromDto(response.data);
                        load.Calculate(false);
                    })
                    .catch(error => load.Calculate(false));
            },
            sendPush: function() {

                if(!this.pushText || !this.id) {
                    dialogService.showAlert('Предупреждение', 'Заполните текст уведомления');
                    return;
                }
                    
                apiService.Admin.Users.PostSendPush(this.id, this.pushText)
                    .then(response => {
                        dialogService.showAlert( 'Информация', 'Уведомление успешно отправлено');
                     })
                    .catch(error => {
                        dialogService.showAlert( 'Ошибка', 'Уведомление не отправлено.');
                    });                
            },
            updateUser: function() {

                if(!this.entity.isValid()) {
                    dialogService.showAlert('Предупреждение', 'Вы не заполнили обязательные поля');
                    return;
                }
                this.load.Calculate(true);          

                let user = this.entity.mapToDto();

                if(this.id != null){
                    apiService.Admin.Users.PostUpdate(user)
                        .then(response => {                        
                            this.$router.push(AllRoutes.Admin.Users.Index);
                        })
                        .catch(error => this.load.Calculate(false));
                }
                else {
                    apiService.Admin.Users.PostCreate(user)
                        .then(response => {                        
                            this.$router.push(AllRoutes.Admin.Users.Index);
                        })
                        .catch(error => this.load.Calculate(false));
                }
                    
            },
            deleteUserDialog: function() {                
                dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данного пользователя?')
                    .then(ok => {
                        this.deleteUser();
                    })
                    .catch(cancel => { });
            },
            deleteUser: function() {
                this.load.Calculate(true);

                apiService.Admin.Users.PostDelete(this.entity.Id)
                    .then(response => {
                        this.$router.push(AllRoutes.Admin.Users.Index);
                    })
                    .catch(error => this.load.Calculate(false));
            },
            isDaxUser: function(value) {
                if(!this.id) 
                    return;

                if(value.Id == 5) 
                    return;

                this.load.Calculate(true);
                dialogService.showAlert( 'Информация', 'Проверка пользователя');

                apiService.Admin.Users.GetCheckIsDaxUser(this.entity.PhoneNumber)
                    .then(response => {                        
                        if(!response.data.IsDaxUser){
                            this.selectedType = this.rightsService.Public;
                            dialogService.showAlert( 'Информация', 'Пользователь c указанным номером телефона не найден в DAX');
                       }
                       else{
                           this.entity.mapFromDaxUser(response.data);
                           dialogService.showAlert( 'Информация', 'Тип успешно сменен');
                       }
                       this.load.Calculate(false);             
                    })
                    .catch(error => this.load.Calculate(false));
            },
            format: function(value, event) {
                if(!value) return;              
                          
                if(!value.match(/^\+/))
                {
                    value = "+".concat(value);
                }

                return value.substr(0, 12);                                     
			}
        },
    components: {
        Spinner,
        CustomMultiselect
    }
        
}
</script>
